import z from "zod";

const deviceLocationDataSchema = z.object({
    ip: z.string(),
    code: z.string(),
    chargeId: z.string(),
    deviceSerial: z.string(),
    location: z.object({
        new: z.object({ latitude: z.number(), longitude: z.number(), timestamp: z.number() }),
        old: z.object({ latitude: z.number(), longitude: z.number(), timestamp: z.number() }),
    }),
});

const deviceMemoryDataSchema = z.object({
    ip: z.string().optional(),
    code: z.string().optional(),
    chargeId: z.string().optional(),
    deviceSerial: z.string().optional(),
    memory: z.object({ new: z.string(), old: z.string() }),
});

const deviceBatteryHealthDegradedDataSchema = z.object({
    deviceSerial: z.string(),
    chargeId: z.string(),
    code: z.string(),
    health: z.object({ old: z.string(), new: z.string() }),
    battery_snapshot: z
        .object({
            status: z.string().optional(),
            plugged: z.string().optional(),
            voltage: z.number().optional(),
            percentage: z.number().optional(),
            temperature: z.number().optional(),
        })
        .optional(),
});

const deviceDataSchema = z.object({
    ip: z.string(),
    code: z.string(),
    chargeId: z.string(),
    deviceSerial: z.string(),
});

const deviceUpdatedDataSchema = z.object({
    ip: z.string().optional(),
    code: z.string().optional(),
    chargeId: z.string().optional(),
    deviceSerial: z.string().optional(),
    emteriaVersion: z.object({ new: z.string(), old: z.string() }),
});

export { deviceBatteryHealthDegradedDataSchema, deviceDataSchema, deviceLocationDataSchema, deviceMemoryDataSchema, deviceUpdatedDataSchema };
